import { Box, Skeleton } from "@repo/ui";

const WebinarCardLoader = () => {
  return (
    <Box className="border rounded-md">
      <Skeleton width={100} size={190}>
        <svg
          className="size-12"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 18"
        >
          <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
        </svg>
      </Skeleton>
      <Box className="p-4">
        <Skeleton className="mt-4" width={80} size={24} />
        <Skeleton className="mt-8" width={70} size={18} />
        <Skeleton className="mt-4" width={70} size={18} />
        <Skeleton className="mt-4" width={70} size={18} />

        <Box className="mt-12 flex gap-4 items-center">
          <Skeleton className="!w-12 !h-10 shrink-0" />
          <Skeleton width={100} size={40} />
        </Box>
      </Box>
    </Box>
  );
};

export default WebinarCardLoader;
